import React from 'react';
import { useNavigate } from 'react-router-dom';

import energyModalIcon from '../../assets/energy_modal.png';
import energyIcon from '../../assets/energy.png';
import coinIcon from '../../assets/coin.png';
import closeIcon from '../../assets/closeIcon.png';
import './EnergyModal.css';

const EnergyModal = ({ isOpen, onClose }) => {

    const getMobileOS = () => {
        const ua = navigator.userAgent
        if (/android/i.test(ua)) {
          return "Android"
        }
        else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)){
          return "iOS"
        }
        return "Other"
    }

    const navigate = useNavigate();

    const handleSpeedUpClick = () =>{
        navigate('/boosts');
    }

    const handleEarnCoinsClick = () =>{
        navigate('/earn');
    }

    return (
        isOpen?<div className="modal-overlay">
            <div className="modal">
                <div className="modal-header">
                    <img src={energyModalIcon} alt="Energy Modal Icon" className="modal-icon" />
                    <button style={{ position: 'absolute', top: '0rem', right: '0rem', float: 'right', background: 'none', border: 'none', cursor: 'pointer' }} onClick={onClose}>
                        <img src={closeIcon} alt="Close Icon" style={{ width: '1.5rem', height: '1.5rem' }} />
                    </button>
                </div>
                <div className="modal-title">
                    <h2>Attempts Restoring</h2>
                </div>
                <div className="modal-body">
                    <p className="modal-message">Meanwhile you can watch ads to restore attempts or earn tokens by completing tasks</p>
                </div>
                <div className="modal-footer">
                    <button className="modal-button" onClick={handleSpeedUpClick}>
                        <img src={energyIcon} alt="Energy Icon" className="button-icon" />
                        Speed Up
                    </button>
                    <button className="modal-button" onClick={handleEarnCoinsClick}>
                        <img src={coinIcon} alt="Coin Icon" className="button-icon" />
                        Earn Coins
                    </button>
                </div>
            </div>
        </div>:""
    );
};

export default EnergyModal;
